export const useSellerPrivate = `공고일자: 2026년 10월 1일 · 시행일자: 2026년 10월 1일
기역기역 주식회사(이하 "회사")는 「개인정보 보호법」 제30조에 따라 팬버드에 입점하는 셀러(대표자, 담당자 등 개인을 포함)의 개인정보를 어떻게 처리하는지 알리기 위해 다음과 같이 개인정보 처리방침을 수립·공개합니다.
제1조 (처리 목적, 항목, 근거 및 보유기간)
처리 목적
처리 항목
처리 근거
보유기간
입점 신청, 심사, 계약 체결
[필수] 상호, 대표자명, 사업자등록번호, 통신판매업 신고번호, 사업장 주소, 휴대전화번호, 이메일, 본인인증 결과(이름, 생년월일, CI) 또는 주민등록번호 뒷자리를 가린 신분증 사본 / [해당 시] 품목별 인허가·신고 서류, 소매 판매 확약서
계약 체결·이행(법 제15조 제1항 제4호), 판매자 신원 확인 의무(제2호, 전자상거래법)
퇴점 시까지
판매자 신원정보 공개
상호, 대표자명, 사업장 주소, 전화번호, 이메일, 사업자등록번호, 통신판매업 신고번호
법령상 의무(법 제15조 제1항 제2호, 전자상거래법)
퇴점 시까지
코인 충전·환불, 판매대금 정산, 세금계산서 발행
[필수] 은행명, 예금주명, 계좌번호, 세금계산서 수신 이메일, 입금자명, 충전·차감·환불 내역
계약 이행(제4호), 법령상 의무(제2호, 부가가치세법)
법정 보존기간(제2조)
라이브 방송 제공 및 홍보
방송 영상에 포함된 대표자·출연자의 얼굴, 음성, 채팅 기록
계약 이행(제4호)
퇴점 시까지
서비스 공지, 알림 발송, 상담
휴대전화번호, 이메일, 상담 내용
계약 이행(제4호)
퇴점 시까지(상담기록은 3년)
하위 계정 관리
[선택] 직원 이름, 휴대전화번호, 이메일
계약 이행(제4호)
하위 계정 삭제 시까지
외부 채널 유도·직거래·가품 등 부정행위 모니터링
[자동수집] IP 주소, 기기정보, 접속 기록, 판매·방송·채팅 기록, 제재 이력
정당한 이익(제6호)
수집일부터 1년(웹사이트 방문기록은 최소 3개월)
부정 재입점 방지
퇴점 셀러의 대표자명, 사업자등록번호, 연락처, 제재 이력
정당한 이익(제6호)
퇴점 후 1년
제2조 (법령에 따른 보존)
보존 항목
기간
근거 법령
상업장부와 영업에 관한 중요서류
10년
상법 제33조
세금계산서 등 국세 증빙서류
5년
국세기본법, 부가가치세법
대금결제 및 재화 공급, 계약·청약철회에 관한 기록
5년
전자상거래법
소비자 불만 또는 분쟁처리에 관한 기록
3년
전자상거래법
웹사이트 방문 기록
3개월
통신비밀보호법
제3조 (개인정보의 제3자 제공)
① 회사는 셀러의 개인정보를 제1조의 목적 범위에서만 처리하며, 다음의 경우에만 제3자에게 제공합니다.
제공받는 자
목적
항목
근거
플랫폼 이용자(고객)
거래 상대방 신원 확인
상호, 대표자명, 사업장 주소, 전화번호, 이메일, 사업자등록번호, 통신판매업 신고번호
전자상거래법(법령상 의무)
주식회사 헥토파이낸셜
PG 가맹 심사 및 계약(PG결제를 선택한 셀러)
상호, 대표자명, 사업자등록번호, 연락처, 정산계좌, 제출 서류
셀러의 동의(PG 신청 시)
국세청 등 과세관청
결제대행 자료·세금계산서 제출
사업자등록번호, 상호, 대표자명, 거래금액
부가가치세법 등
수사기관, 분쟁조정기관 등
적법한 영장·요청에 따른 제공
요청 범위의 정보
형사소송법, 전자상거래법 등
② 고객 분쟁 처리를 위해 소비자분쟁조정위원회, 공정거래위원회, 지방자치단체가 요청하는 경우 셀러의 신원정보를 제공할 수 있습니다.
제4조 (개인정보 처리업무의 위탁)
수탁자
위탁 업무
주식회사 헥토파이낸셜
결제대금 수납 및 판매대금 정산 대행
주식회사 알리고
셀러 대상 알림톡·문자(방송 시작, 정산·코인 충전 안내 등) 발송 대행
Amazon Web Services, Inc.
클라우드 서버 운영, 라이브 영상 송출·저장(AWS IVS), 데이터베이스 관리
위탁 기간은 퇴점 또는 위탁계약 종료 시까지이며, 회사는 위탁계약서에 목적 외 처리 금지, 안전조치, 재위탁 제한, 관리·감독, 손해배상 사항을 정하고 수탁자를 감독합니다.
제5조 (개인정보의 국외 이전)
회사는 AWS 아시아 태평양(서울) 리전에 개인정보와 방송 영상을 저장하며, 현재 국외로 이전하지 않습니다.
제6조 (개인정보의 파기)
① 회사는 보유기간이 끝나거나 처리 목적을 달성한 개인정보를 지체 없이 파기하며, 법령에 따라 보존하는 정보는 분리하여 보관한 후 기간이 끝나면 파기합니다.
② 전자적 파일은 복구할 수 없는 방법으로 삭제하고, 신분증 사본 등 종이 문서는 분쇄 또는 소각합니다. 신분증 사본은 본인확인 완료 후 30일 이내에 파기합니다.
제7조 (정보주체의 권리와 행사 방법)
① 셀러(대표자, 담당자 등)는 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회를 요구할 수 있으며, 셀러센터, 이메일, 서면으로 행사할 수 있습니다. 회사는 10일 이내에 조치하고 결과를 알립니다.
② 법령상 공개·보존 의무가 있는 정보(판매자 신원정보, 거래 기록 등)는 그 의무 기간 동안 삭제나 처리정지가 제한될 수 있으며, 이 경우 회사는 사유를 알립니다.
③ 대리인을 통한 권리 행사는 「개인정보 처리 방법에 관한 고시」에 따른 위임장을 제출하여야 합니다.
④ 회사는 입점 심사와 제재를 완전히 자동화된 방식으로만 결정하지 않으며, 담당자가 최종 검토합니다.
제8조 (안전성 확보조치)
1. 관리적 조치: 내부관리계획 수립·시행, 취급자 최소화와 정기 교육, 수탁자 점검
2. 기술적 조치: 접근권한 관리와 접근통제, 계좌번호·본인인증 정보 암호화 저장, 전송구간 암호화(TLS), 접속기록 보관·점검, 신분증 사본 열람 권한 제한
3. 물리적 조치: 보안 인증을 받은 클라우드 시설 이용, 문서 보관 장소 접근 통제
제9조 (자동수집장치의 설치·운영 및 거부)
회사는 셀러센터 로그인 유지와 보안을 위해 쿠키를 사용합니다. 셀러는 브라우저 설정에서 쿠키를 거부할 수 있으나, 이 경우 셀러센터 이용이 제한될 수 있습니다.
제10조 (셀러가 처리하는 고객 개인정보)
셀러가 주문 처리를 위해 회사로부터 제공받은 고객 개인정보는 셀러가 개인정보처리자로서 처리하며, 셀러는 배송·교환·반품·상담 목적 외 이용 금지, 주문일부터 3개월 이내 열람, 목적 달성 후 파기, 유출 시 즉시 신고 등 셀러 이용약관 제22조의 의무를 지켜야 합니다.
제11조 (개인정보 보호책임자)
• 성명: 이헌영 / 직위: 대표이사
• 전화: 0507-1336-7115 / 이메일: linkcampus01@gmail.com
제12조 (권익침해 구제방법)
• 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)
• 개인정보침해신고센터: 국번 없이 118 (privacy.kisa.or.kr)
• 대검찰청: 국번 없이 1301 (www.spo.go.kr)
• 경찰청: 국번 없이 182 (ecrm.police.go.kr)
제13조 (처리방침의 변경)
이 처리방침을 변경하는 경우 시행 7일 전부터 셀러센터 공지로 알리며, 수집 항목 추가나 제3자 제공 등 중요한 변경은 30일 전부터 알리고 개별 통지합니다.`;
